<template>
  <div class="code-line">
    <div class="code-line-head">
      <div class="code-line-title" v-if="title">{{ title }}</div>
      <div class="code-line-subtitle" v-if="titleRight">{{ titleRight }}</div>
    </div>

    <div class="code-line-content" v-if="isRevealed">
      <pre>
          <code>{{ code }}</code>
        </pre>

      <button class="button is-text" :name="title" :data-clipboard-text="code">
        <i class="mdi mdi-content-copy"></i>
      </button>
    </div>

    <a
      v-if="!isRevealed"
      class="code-line-reveal is-inline-block"
      @click="$emit('reveal')"
    >{{ $t('applications.reveal_code') }}</a>
  </div>
</template>

<script>
export default {
  name: "CodeLine",
  props: {
    title: {
      type: String
    },
    titleRight: {
      type: String
    },
    isRevealed: {
      type: Boolean,
      default: true
    },
    code: {
      type: String
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~scss/utilities/initial-variables.scss";
@import "~scss/utilities/derived-variables.scss";

.code-line {
  margin-top: 0.5rem;

  &:first-child {
    margin: 0;
  }
}

.code-line-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.code-line-title {
  font-size: 0.6875rem;
  font-weight: 600;
  color: rgba($black, 0.64);
  text-transform: uppercase;
}

.code-line-subtitle {
  font-size: 0.625rem;
  font-weight: 600;
  letter-spacing: 0.2px;
  color: rgba($black, 0.24);
}

.code-line-content {
  display: flex;
  margin-top: 0.25rem;
}

.code-line-reveal {
  margin-top: 0.5rem;
  height: 25px;
  font-size: 0.8125rem;
  color: $blue;
}

.button {
  padding: 0 0.5rem;
  background-color: #f1f3f7;
  color: rgba($black, 0.4);
  border-top-right-radius: $radius;
  border-bottom-right-radius: $radius;
  transition: $transition;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -1rem;
    width: 1rem;
    height: 100%;
    background: linear-gradient(to right, rgba($white, 0) 0%, #f1f3f7 100%);
  }

  &:hover,
  &.is-hovered,
  &:focus,
  &.is-focused {
    color: rgba($black, 0.64);
  }
}

pre {
  position: relative;
  display: flex;
  flex: 1;
  padding: 0.25rem 0.5rem;
  border-radius: $radius;
  background-color: #f1f3f7;
  color: rgba($black, 0.4);

  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

pre::-webkit-scrollbar {
  height: 0px;
}

code {
  padding-right: 0.5rem;
}
</style>
